type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export function SearchBar({
  value,
  onChange,
  placeholder = "Search...",
}: Props) {
  return (
    <input
      className="w-full max-w-md rounded-lg border border-slate-800 bg-slate-950 px-3 py-2 text-white outline-none focus:border-emerald-500"
      aria-label={placeholder}
      type="search"
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
